<template>
  <CToaster placement="top-end" class="p-3">
    <CToast
      v-for="notification in notifications"
      :key="notification.id"
      :color="colorFor(notification.type)"
      visible
      class="text-white align-items-center"
      @close="dismiss(notification.id)"
    >
      <div class="d-flex">
        <CToastBody>
          <i :class="iconFor(notification.type)" class="me-2"></i>
          {{ notification.message }}
        </CToastBody>
        <CToastClose class="me-2 m-auto" white />
      </div>
    </CToast>
  </CToaster>
</template>

<script>
  import { computed } from 'vue'
  import { useStore } from 'vuex'

  const COLORS = {
    success: 'success',
    error: 'danger',
    danger: 'danger',
    warning: 'warning',
    info: 'info',
  }

  const ICONS = {
    success: 'fas fa-circle-check',
    error: 'fas fa-circle-exclamation',
    danger: 'fas fa-circle-exclamation',
    warning: 'fas fa-triangle-exclamation',
    info: 'fas fa-circle-info',
  }

  export default {
    name: 'AppNotifications',
    setup() {
      const store = useStore()

      return {
        notifications: computed(() => store.state.notifications),
        colorFor: (type) => COLORS[type] || 'info',
        iconFor: (type) => ICONS[type] || ICONS.info,
        dismiss: (id) => store.dispatch('dismissNotification', id),
      }
    },
  }
</script>
